import { useState } from "react";
import { Link } from "react-router-dom";
import { neighborhoods } from "@/mocks/neighborhoods";

const MOBILE_VISIBLE = 6;

export default function NeighborhoodsSection() {
  const [expanded, setExpanded] = useState(false);
  const visibleBarrios = expanded ? neighborhoods : neighborhoods.slice(0, MOBILE_VISIBLE);
  const hasMore = neighborhoods.length > MOBILE_VISIBLE;

  return (
    <section id="barrios" className="py-10 md:py-20 bg-gradient-to-br from-background-100 via-primary-50/20 to-accent-50/20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <p className="text-xs md:text-sm text-primary-600 font-medium mb-2 md:mb-3 uppercase tracking-wider">Cobertura local Málaga</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3 font-heading">
            Tu barrio de Málaga, nuestra zona de trabajo
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Damos servicio en los 16 barrios principales de Málaga capital. ¿El tuyo no aparece? Llámanos, seguro que vamos.
          </p>
        </div>

        {/* Google Map Málaga centro */}
        <div className="w-full rounded-2xl overflow-hidden mb-6 md:mb-8 border border-background-200/60 h-48 sm:h-64 md:h-[400px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d102347.428765434!2d-4.487518624414005!3d36.72015851603788!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72f4e1f3b3b3b3%3A0x8e2e8c8c8c8c8c8c!2sM%C3%A1laga%2C+Spain!5e0!3m2!1ses!2ses!4v1718400000000"
            width="100%"
            height="100%"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Málaga capital — Servicio de persianas en los 16 barrios"
            className="w-full h-full"
          />
        </div>

        {/* Barrio badges */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-3">
          {visibleBarrios.map((barrio) => (
            <Link
              key={barrio.slug}
              to={`/barrios/${barrio.slug}`}
              className="flex items-center gap-2 px-3 md:px-4 py-3 bg-background-50 hover:bg-primary-100/80 rounded-xl border border-background-200/60 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-5 h-5 md:w-7 md:h-7 flex items-center justify-center rounded-full bg-primary-500/10 flex-shrink-0">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-map-pin-fill text-primary-600 text-xs md:text-sm"></i></span>
              </div>
              <span className="text-xs md:text-sm font-semibold text-foreground-800 whitespace-nowrap truncate">{barrio.name}</span>
            </Link>
          ))}
        </div>

        {hasMore && (
          <div className="mt-4 text-center">
            <button
              onClick={() => setExpanded(!expanded)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-semibold text-sm rounded-full border border-background-200 transition-all cursor-pointer"
            >
              {expanded ? (
                <>Ver menos <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-up-s-line"></i></span></>
              ) : (
                <>Ver los {neighborhoods.length} barrios <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-down-s-line"></i></span></>
              )}
            </button>
          </div>
        )}

        <div className="text-center mt-6 md:mt-8">
          <Link to="/contacto" className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill"></i></span>
            <span className="font-medium">Contacta con nosotros: 951 12 07 70</span>
          </Link>
        </div>
      </div>
    </section>
  );
}